/**
 * @typedef {Object} OutputField
 * @property {string} name - Field identifier
 * @property {string|function} label - Display label or function returning label
 * @property {function} [checked] - Function determining if field is selected by default
 * @property {function} [visible] - Function determining if field should be shown
 * @property {boolean} [forceChecked] - If true, field is always selected and cannot be unchecked
 * @property {function} [disabled] - Function determining if fields should be disabled
 */

const trendedPOSOutputFields = [
  {
    name: "npi",
    label: "Organization NPI",
    checked: ({ common }) => !!common?.outputs?.npi
  },
  {
    name: "name",
    label: "Organization Name",
    checked: ({ common }) => !!common?.outputs?.name
  },
  {
    name: "classification",
    label: "Organization Classification",
    checked: ({ common }) => !!common?.outputs?.classification
  },
  {
    name: "specialization",
    label: "Organization Specialization",
    checked: ({ common }) => !!common?.outputs?.specialization
  },

  {
    name: "icd10Cm",
    label: "ICD-10-CM",
    checked: ({ common }) => !!common?.outputs?.icd10Cm
  },
  {
    name: "codeServiceLine",
    label: "Code Service Line",
    checked: ({ common }) => !!common?.outputs?.codeServiceLine
  },
  {
    name: "codeDescription",
    label: "Code Description",
    checked: ({ common }) => !!common?.outputs?.codeDescription
  },

  {
    name: "year",
    label: "Year",
    checked: ({ common }) => !!common?.outputs?.year
  },
  {
    name: "quarter",
    label: "Quarter",
    checked: ({ common }) => !!common?.outputs?.quarter
  },

  {
    name: "address",
    label: "Address",
    checked: ({ common }) => !!common?.outputs?.address
  },
  {
    name: "city",
    label: "City",
    checked: ({ common }) => !!common?.outputs?.city
  },
  {
    name: "zipCode",
    label: "ZIP Code",
    checked: ({ common }) => !!common?.outputs?.zipCode
  },
  {
    name: "placeOfService",
    label: "Place of Service",
    forceChecked: true
  },

  {
    name: "source",
    label: "Source",
    checked: ({ common }) => !!common?.outputs?.source
  },
  {
    name: "distinctClaimsCount",
    label: "Count of Distinct Claims",
    checked: ({ common }) => !!common?.outputs?.distinctClaimsCount
  },
  {
    name: "distinctPatientsCount",
    label: "Count of Distinct Patients",
    checked: ({ common }) => !!common?.outputs?.distinctPatientsCount
  },
  {
    name: "proceduresCount",
    label: "Count of Procedures",
    checked: ({ common }) => !!common?.outputs?.proceduresCount
  },
  {
    name: "sumCharges",
    label: "Sum of Charges",
    checked: ({ common }) => !!common?.outputs?.sumCharges
  }
];

export default trendedPOSOutputFields;
